<!-- 查看详情 -->
<template>
  <a-modal
    title="查看登录详情"
    width="1000px"
    :visible="visible"
    @cancel="onClose"
  >
    <TableList
      :columns="columns"
      :loading="loading"
      :tableData="tableData"
      :pageInfo="pageBean"
      :scroll="{ y: 680, x: 1000 }"
      @getList="changePage"
    />
    <template slot="footer">
      <a-button @click.stop="onClose">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import TableList from "@/components/table/TableList"; // 表格组件
import API from "@/api/logManage.js"; // 请求接口
export default {
  components: {
    TableList,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    columns() {
      const data = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 70,
          align: "center",
          ellipsis: true,
          fixed: "left",
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "登入时间",
          dataIndex: "loginTime",
          key: "loginTime",
          ellipsis: true,
          width: 100,
          customRender: (text, row, index) => {
            return text || "-";
          },
        },
        {
          title: "登出时间",
          dataIndex: "logoutTime",
          key: "logoutTime",
          ellipsis: true,
          width: 100,
          customRender: (text, row, index) => {
            return text || "-";
          },
        },
        {
          title: "时长(小时)",
          dataIndex: "loginDuration",
          key: "loginDuration",
          ellipsis: true,
          width: 100,
          customRender: (text, row, index) => {
            return text || "-";
          },
        },
      ];
      return data;
    },
  },
  data() {
    return {
      pageBean: {
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
      },
      params: {
        userId: "",
      },
      loading: false,
      tableData: [], // 列表数据
      visible: false,
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 查询
    handleSearch(obj) {
      this.pageBean.pageNum = 1;
      this.pageBean.pageSize = 10;
      this.params = obj ? obj : this.params;
      this.$nextTick(() => {
        this.getData(this.pageBean.pageNum);
      });
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let newParams = {};
      newParams = this.params;

      API.getUserSessionDetail(
        {
          data: {
            params: {
              ...newParams,
            },
            pageBean: {
              pageNum: pageNum,
              pageSize: this.pageBean.pageSize,
            },
          },
        },
        (callback) => {
          this.loading = false;
          let list = []; // 数据
          if (callback.status == "S" && callback.data) {
            const pageBean = { ...this.pageBean };
            pageBean.total = callback.data.total || 0;
            pageBean.pageNum = pageNum || 1;
            this.pageBean = pageBean;

            if (
              Array.isArray(callback.data.list) &&
              callback.data.list.length > 0
            ) {
              callback.data.list.map((item, index) => {
                item.key = index;
              });
              list = callback.data.list;
            }

            this.tableData = list;
          }
        }
      );
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current;
      this.pageBean.pageSize = page.pageSize;
      this.getData(this.pageBean.pageNum);
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.params.userId = this.modalData.id || "";
        this.handleSearch();
      }
    },
  },
};
</script>
